import { BrowserRouter as Router } from 'react-router-dom';
import { NotificationsProvider } from './screens/Notifications/NotificationContext.jsx';
import { AvizProvider } from './contexts/AvizContext.jsx';
import React, { useEffect } from 'react';
import ErrorHandlingService from './services/notifications/errorHandlingService';
import AppContent from './AppContent';
import ErrorBoundary from './components/ErrorBoundary.js';
import TenantConfigurationError from './components/TenantConfigurationError.jsx';
import { isPublicFrontendHostname, tryResolveTenantSlug } from './tenancy/tenant.js';
import { useLanguage } from './i18n/LanguageContext.jsx';
import './App.css';

const PUBLIC_ROUTE_PREFIXES = ['/temp/', '/expeditor', '/ecmr/verify/'];

function App() {
  // Keep legacy screens that read the active locale outside React in sync
  // without remounting them (and therefore without losing form state).
  useLanguage();

  // Initialize error handling service
  useEffect(() => {
    ErrorHandlingService.initialize();
  }, []);

  const tenantSlug = tryResolveTenantSlug();
  const temporaryAccessPage = typeof window !== 'undefined'
    && window.location.pathname.startsWith('/temp/');
  const publicPage = typeof window !== 'undefined'
    && isPublicFrontendHostname(window.location.hostname)
    && PUBLIC_ROUTE_PREFIXES.some((prefix) => window.location.pathname.startsWith(prefix));

  if (!tenantSlug && !publicPage) {
    return <TenantConfigurationError />;
  }

  return (
    <Router>
      <NotificationsProvider disabled={temporaryAccessPage}>
        <AvizProvider>
          <ErrorBoundary>
            <AppContent />
          </ErrorBoundary>
        </AvizProvider>
      </NotificationsProvider>
    </Router>
  );
}

export default App;
